module.exports = __webpack_public_path__ + "img/sec-10.5a96fd5e.png";